import styled from "@emotion/styled";
import theme from "@theme";
import InnoIcons from "InnoUI/innoicons";

const BodyHeader = styled.div`
  padding: 16px 24px;
  background: linear-gradient(135deg, #e36e00 0%, #ffae00 100%);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  position: fixed;
  width: 100%;
  z-index: 1000;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
`;

const InputStyle = styled.input`
  width: 100%;
  height: 40px;
  padding: 12px 12px 12px 40px;
  font-size: 14px;
  border: 1px solid rgba(227, 110, 0, 0.2);
  border-radius: ${theme.modernTokens.borderRadius.md};
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(10px);
  transition: ${theme.modernTokens.transitions.normal};

  &:focus {
    outline: none;
    border-color: ${theme.colors.modernPrimary};
    box-shadow: 0 0 0 3px rgba(227, 110, 0, 0.1);
  }

  &::placeholder {
    color: ${theme.colors.modernGray[400]};
  }
`;

const BodyContainer = styled.div`
  margin-top: 60px;
  border-bottom: 1px solid rgba(227, 110, 0, 0.1);
  display: flex;
  padding: 16px 24px;
  justify-content: space-between;
  align-items: center;
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(10px);
`;

const Container = styled.div``;

const HeadingTag = styled.p`
  float: left;
  margin: 8px;
  padding: 0px 24px 0px 0px;
  font-weight: 600;
  font-size: 16px;
  color: #2d3748;
`;

const SearchIcon = styled(InnoIcons.SearchIcon)`
  position: absolute;
  left: 12px;
  color: ${theme.colors.modernGray[400]};
  font-size: 20px;
`;

const InputContiner = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  width: 500px;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  gap: 12px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
`;

const HeaderStyle = styled.div`
  font-size: 1.25rem;
  font-weight: 700;
  background: linear-gradient(135deg, #e36e00 0%, #ffae00 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  letter-spacing: -0.3px;
  line-height: 1.2;

  @media (min-width: 640px) {
    font-size: 1.5rem;
  }

  @media (min-width: 1024px) {
    font-size: 1.75rem;
  }

  @media (min-width: 1280px) {
    font-size: 2rem;
  }
`;

const CountStyle = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: #e36e00;
  padding: 6px 12px;
  background: rgba(227, 110, 0, 0.1);
  border-radius: ${theme.modernTokens.borderRadius.full};
  border: 1px solid rgba(227, 110, 0, 0.2);

  @media (max-width: 768px) {
    font-size: 12px;
    padding: 4px 8px;
  }
`;

const TabDiv = styled.div`
  display: flex;
  gap: 20px;
  align-items: baseline;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 12px;
  }
`;

const PopoverContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const PopoverSpan = styled.span`
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(10px);
  border-radius: ${theme.modernTokens.borderRadius.md};
  padding: 8px 12px;
  border: 1px solid rgba(227, 110, 0, 0.1);
  cursor: pointer;
  transition: ${theme.modernTokens.transitions.normal};

  &:hover {
    background: rgba(255, 255, 255, 1);
    border-color: rgba(227, 110, 0, 0.2);
    transform: translateY(-1px);
    box-shadow: ${theme.modernTokens.shadows.sm};
  }
`;

const MoreVertIcon = styled(InnoIcons.MoreVertIcon)`
  font-size: 18px;
  cursor: pointer;
  color: ${theme.colors.modernPrimary};
  transition: ${theme.modernTokens.transitions.normal};

  &:hover {
    color: ${theme.colors.modernSecondary};
    transform: scale(1.1);
  }
`;

const CardContainerStyle = styled.div`
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 1.25rem;
  padding: 1.5rem;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;
  height: 100%;
  width: 100%;
  min-width: 0;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 25px 50px rgba(0, 0, 0, 0.15);
  }

  @media (min-width: 640px) {
    padding: 2rem;
    border-radius: 1.5rem;
  }

  @media (min-width: 1024px) {
    padding: 2.5rem;
  }

  @media (min-width: 1280px) {
    padding: 1rem;
  }
`;

const SC = {
  Container,
  BodyHeader,
  BodyContainer,
  HeadingTag,
  InputStyle,
  SearchIcon,
  InputContiner,
  HeaderContainer,
  HeaderStyle,
  CountStyle,
  SearchIcon,
  InputStyle,
  TabDiv,
  PopoverContainer,
  PopoverSpan,
  MoreVertIcon,
  CardContainerStyle,
};

export default SC;
